if (import.meta.env.VITE_BRAND === 'sweeply') {
    window.checksumai?.init('phc_JRUMUbCv6GnYS5hIku3Ky5oJg4FuhI74RjmANGVhX8q')
}
